import reducer from "./reducers";

import * as workforceAction from "./actions";

export { workforceAction };

export default reducer;
